<template>
  <div class="content">
    <div class="header">
      人群划分
      <span class="paddingLR6">-</span>
      <strong>编辑人群</strong>
    </div>
    <div class="bottom">
      <div class="box">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="人群名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              size="small"
              class="fixed300"
            ></el-input>
          </el-form-item>

          <el-form-item label="人群描述">
            <el-input
              type="textarea"
              v-model="ruleForm.desc"
              class="fixed500"
            ></el-input>
          </el-form-item>
          <el-form-item label="人群分类" prop="region">
            <div class="flex">
              <el-select
                v-model="ruleForm.region"
                placeholder="请选择活动区域"
                size="small"
              >
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
              <el-button type="text" class="paddingLR6">刷新</el-button>
              <el-button type="text">新增</el-button>
            </div>
          </el-form-item>
          <el-form-item label="选择条件" prop="region">
            <el-button size="mini" @click="addMethods(0)">新建条件</el-button>
          </el-form-item>
          <div
            class="showMethods"
            v-for="(item, index) in choseMethods"
            :key="index"
          >
            <div class="methods-left">
              <div
                class="miniBoxtop"
                v-show="index < choseMethods.length && index != 0"
              ></div>
              <div
                class="miniBox"
                v-show="index < choseMethods.length - 1"
              ></div>
              <div
                class="sign"
                v-show="index < choseMethods.length && index != 0"
              >
                并且
              </div>
            </div>

            <div class="methods">
              <div class="inline">
                <div>
                  <div class="item">
                    <strong class="padding6">消费时间:</strong>
                    首次消费时间：2020/03/13-2020/04/11；
                  </div>
                  <div
                    class="item flex"
                    v-for="(son, index) in item.children"
                    :key="index"
                  >
                    <div class="second">
                      或者
                    </div>
                    <div>
                      <strong class="padding6">消费时间:</strong>
                      首次消费时间：2020/03/13-2020/04/11；
                    </div>
                  </div>
                  <div class="item add">
                    <el-button
                      type="text"
                      icon="el-icon-plus"
                      @click="addMethods(1, index)"
                      >添加平行条件</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-form-item label="更新时间">
            <div>系统每日00:00--06：00自动更新</div>
            <div>
              新建/编辑时不自动更新，您可点击列表中的【手动更新】操作立刻执行当前条件（每日最多可执行
              2 次）
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 条件弹窗 -->
    <el-dialog title="新建条件" :visible.sync="dialogFormVisible" width="900px">
      <div class="panel">
        <div class="panel-left">
          <el-tree
            :data="data"
            :indent="0"
            accordion
            highlight-current
            node-key="sign"
            :default-expanded-keys="['a', '0']"
            @node-click="handleNodeClick"
          >
          </el-tree>
        </div>
        <div class="panel-right">
          <div class="box" v-show="signStatus == '0'">
            <div class="box-top">
              <el-checkbox v-model="checked" class="checkbox"
                >首次消费时间</el-checkbox
              >
              <div class="padding40">
                <div class="title">
                  <el-radio v-model="radio" label="1">固定日期</el-radio>
                </div>
                <div>
                  <el-date-picker
                    v-model="value1"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="mini"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="padding40">
                <div class="title">
                  <el-radio v-model="radio" label="1"
                    >首次消费时间距当前</el-radio
                  >
                </div>
                <div class="flex">
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                  <div class="paddingLR6">-</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-bottom">
              <el-checkbox v-model="checked" class="checkbox"
                >首次消费时间</el-checkbox
              >
              <div class="padding40">
                <div class="title">
                  <el-radio v-model="radio" label="1">固定日期</el-radio>
                </div>
                <div>
                  <el-date-picker
                    v-model="value1"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="mini"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="padding40">
                <div class="title">
                  <el-radio v-model="radio" label="1"
                    >首次消费时间距当前</el-radio
                  >
                </div>
                <div class="flex">
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                  <div class="paddingLR6">-</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box" v-show="signStatus == '1'">
            <div class="box-top">
              <div class="checkbox">时间范围</div>
              <div class="padding40">
                <div class="title">
                  <el-radio v-model="radio" label="1">固定日期</el-radio>
                </div>
                <div>
                  <el-date-picker
                    v-model="value1"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="mini"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="padding40">
                <div class="title">
                  <el-radio v-model="radio" label="1"
                    >首次消费时间距当前</el-radio
                  >
                </div>
                <div class="flex">
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                  <div class="paddingLR6">-</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-bottom">
              <div class="checkbox">消费商品</div>
              <div class="padding40">
                <div class="title">
                  <el-radio v-model="radio" label="1">指定商品</el-radio>
                </div>
                <div>
                  <el-button size="mini">选择商品</el-button>
                </div>
              </div>
              <div class="padding40">
                <div class="title">
                  <el-radio v-model="radio" label="1">全部商品</el-radio>
                </div>
                <!-- <div class="flex">
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                  <div class="paddingLR6">-</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <!-- 消费数据 -->
          <div class="box" v-show="signStatus == '2'">
            <div class="box-top">
              <div class="checkbox">时间范围</div>
              <div class="padding40">
                <div class="title">
                  <el-radio v-model="radio" label="1">固定日期</el-radio>
                </div>
                <div>
                  <el-date-picker
                    v-model="value1"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="mini"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="padding40">
                <div class="title">
                  <el-radio v-model="radio" label="1"
                    >首次消费时间距当前</el-radio
                  >
                </div>
                <div class="flex">
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                  <div class="paddingLR6">-</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-bottom">
              <div class="checkbox">消费数据</div>
              <div class="padding40">
                <div class="flexCenter">
                  <el-checkbox v-model="checked"></el-checkbox>
                  <div class="paddingLR6">消费金额</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                  <div class="paddingLR6">-</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                </div>
              </div>
              <div class="padding40">
                <div class="flexCenter">
                  <el-checkbox v-model="checked"></el-checkbox>
                  <div class="paddingLR6">消费金额</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                  <div class="paddingLR6">-</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 充值数据 -->
          <div class="box" v-show="signStatus == '3'">
            <div class="box-top">
              <div class="checkbox">时间范围</div>
              <div class="padding40">
                <div class="title">
                  <el-radio v-model="radio" label="1">固定日期</el-radio>
                </div>
                <div>
                  <el-date-picker
                    v-model="value1"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="mini"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="padding40">
                <div class="title">
                  <el-radio v-model="radio" label="1"
                    >首次消费时间距当前</el-radio
                  >
                </div>
                <div class="flex">
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                  <div class="paddingLR6">-</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-bottom">
              <div class="checkbox">充值数据</div>
              <div class="padding40">
                <div class="flexCenter">
                  <el-checkbox v-model="checked"></el-checkbox>
                  <div class="paddingLR6">充值金额</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                  <div class="paddingLR6">-</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                </div>
              </div>
              <div class="padding40">
                <div class="flexCenter">
                  <el-checkbox v-model="checked"></el-checkbox>
                  <div class="paddingLR6">充值次数</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                  <div class="paddingLR6">-</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 充值数据 -->
          <div class="box" v-show="signStatus == '3'">
            <div class="box-top">
              <div class="checkbox">时间范围</div>
              <div class="padding40">
                <div class="title">
                  <el-radio v-model="radio" label="1">固定日期</el-radio>
                </div>
                <div>
                  <el-date-picker
                    v-model="value1"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="mini"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="padding40">
                <div class="title">
                  <el-radio v-model="radio" label="1"
                    >首次消费时间距当前</el-radio
                  >
                </div>
                <div class="flex">
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                  <div class="paddingLR6">-</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-bottom">
              <div class="checkbox">充值数据</div>
              <div class="padding40">
                <div class="flexCenter">
                  <el-checkbox v-model="checked"></el-checkbox>
                  <div class="paddingLR6">充值金额</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                  <div class="paddingLR6">-</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                </div>
              </div>
              <div class="padding40">
                <div class="flexCenter">
                  <el-checkbox v-model="checked"></el-checkbox>
                  <div class="paddingLR6">充值次数</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                  <div class="paddingLR6">-</div>
                  <div class="width90">
                    <el-input size="mini"></el-input>
                    <el-button size="mini" type="info" plain>天</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="closePopup">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      data: [
        {
          sign: "a",
          label: "交易信息",
          children: [
            {
              label: "消费时间",
              sign: "0",
              itemMessage: [
                {
                  mainTitle: "首次消费时间",
                  mainValue: false,
                  mainLower: [
                    {
                      lowerTitle: "固定日期"
                    },
                    {
                      lowerTitle: "首次消费时间距当前",
                      unit: "天"
                    }
                  ]
                },
                {
                  mainTitle: "最近消费时间",
                  mainValue: false,
                  mainLower: [
                    {
                      lowerTitle: "固定日期"
                    },
                    {
                      lowerTitle: "首次消费时间距当前",
                      unit: "天"
                    }
                  ]
                }
              ]
            },
            {
              label: "消费商品",
              sign: "1",
              itemMessage: [
                {
                  mainTitle: "时间范围",
                  mainValue: "", //当为空时不存在多选框,
                  mainLower: [
                    {
                      lowerTitle: "固定日期",
                      unit: ""
                    },
                    {
                      lowerTitle: "首次消费时间距当前",
                      unit: "天"
                    }
                  ]
                },
                {
                  mainTitle: "消费商品",
                  mainValue: "",
                  mainLower: [
                    {
                      lowerTitle: "指定商品",
                      lowerSublevel: [
                        {
                          sublevelTitle: "购买次数",
                          sublevelUnit: "次"
                        },
                        {
                          sublevelTitle: "购买sheng数",
                          sublevelUnit: "次"
                        }
                      ]
                    },
                    {
                      lowerTitle: "全部商品",
                      unit: "天"
                    }
                  ]
                }
              ]
            },
            {
              label: "消费数据",
              sign: "2"
            },
            {
              label: "充值数据",
              sign: "3"
            },
            {
              label: "消费时间",
              sign: "4"
            }
          ]
        },
        {
          sign: "b",
          label: "客户标签",
          children: [
            {
              label: "客户标签",
              sign: "4"
            }
          ]
        },
        {
          sign: "c",
          label: "客户信息",
          children: [
            {
              label: "成为客户",
              sign: "45"
            },
            {
              label: "公众号关注",
              sign: "67"
            },
            {
              label: "成为会员",
              sign: "08"
            },
            {
              label: "客户资料",
              sign: "65"
            }
          ]
        }
      ],
      ruleForm: {
        name: "",
        region: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ]
      },
      dialogFormVisible: false,
      checked: true,
      radio: "",
      value1: "",
      allMessage: [],
      // choseMethods: [1, 2, 3],
      choseMethods: [
        // {
        //   id: "",
        //   index: "",
        //   children: [
        //     {
        //       id: "",
        //       index: ""
        //     }
        //   ]
        // }
      ],
      signStatus: 0, //表示弹窗中页面选中的状态
      addMethodsStatus: 0, //表示平行条件添加的级别状态
      addType: 0
    };
  },
  methods: {
    addMethods(type, index = 0) {
      this.addType = type; // 0，添加父级 1，添加子级
      this.addMethodsStatus = index; //
      this.dialogFormVisible = true;
    },
    closePopup() {
      // 1.用选中状态判断该页的条件是否被选中，否则不能进行下一步
      // let shuju = this.data[this.signStatus].children;
      // for (let i = 0; i < shuju.length; i++) {}
      // 2.先判断添加的级别, 0 ,父级 1，子级
      if (this.addType == 0) {
        console.log("选中状态0", this.signStatus);

        let arr = this.data[this.signStatus].children[0].itemMessage;
        arr.children = [];
        this.choseMethods.push(arr);
      } else {
        //子级条件
        let arr = this.data[this.signStatus].children[0].itemMessage;
        this.choseMethods[this.addMethodsStatus].children.push(arr);
      }

      this.dialogFormVisible = false;
    },
    go(type) {
      this.is_status = type;
      this.$router.push(this.titleDatas[type].path);
    },
    // 节点点击
    handleNodeClick(datas, nodes, indent) {
      console.log("节点点击", datas, nodes, indent);

      if (nodes.level != 1) {
        this.signStatus = datas.sign;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  background: #fff;
  padding: 10px 10px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .header {
    height: 56px;
    font-size: 14px;
    color: #595961;
    line-height: 34px;
    padding: 11px 0;
    display: flex;
  }
  .bottom {
    overflow-y: auto;
    .box {
      width: 100%;
      background: #f2f2f6;
      border-radius: 6px;
      padding: 20px;
    }
  }
}
// 选择条件展示
.showMethods {
  width: 100%;
  height: auto;
  display: flex;

  .methods-left {
    width: 100px;
    height: auto;
    position: relative;
    .sign {
      width: 50px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #fff;
      position: absolute;
      top: -15px;
      left: 30px;
    }
    .miniBox {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 30px;
      height: 30px;
      border-top: 2px dotted #9797a1;
      border-left: 2px dotted #9797a1;
    }
    .miniBoxtop {
      position: absolute;
      right: 0;
      top: 0;
      width: 30px;
      height: 30px;
      border-bottom: 2px dotted #9797a1;
      border-left: 2px dotted #9797a1;
    }
  }
  .methods {
    border-radius: 4px;
    background: #fff;
    width: 950px;
    border: 1px solid #e3e2e5;
    border-left: 4px solid #d0d0dc;
    border-top: none;
    margin-bottom: 20px;

    .item {
      height: 50px;
      line-height: 50px;
      border-top: 1px solid #e3e2e5;
    }
    .padding6 {
      padding: 0 14px;
    }
    .second {
      width: 60px;
      text-align: center;
      border-right: 1px solid #e3e2e5;
      background: #f2f2f6;
    }
    .add {
      text-align: center;
    }
  }
}
// 条件弹窗样式
.panel {
  width: 100%;
  height: 470px;
  display: flex;
  justify-content: space-between;
  .panel-left {
    border: 1px solid #e3e2e5;
    border-radius: 5px;
    width: 25%;
    height: 100%;
    padding: 6px;
    .el-tree {
      .el-tree-node__label {
        color: red !important;
      }
    }
  }
  .panel-right {
    width: 70%;
    height: 100%;
    border-radius: 5px;
    .box {
      height: 100%;
      overflow-y: auto;
      > div {
        height: 230px;
        background: #f2f2f6;
        border-radius: 5px;
      }
      .box-top,
      .box-bottom {
        .checkbox {
          padding: 20px 0 0px 20px;
        }
        .el-radio {
          padding: 10px 0;
        }
        .padding40 {
          margin-left: 40px;
          padding: 10px 0;
        }
      }
      .box-top {
        margin-bottom: 10px;
      }
    }
  }
}
// 统一样式
.width90 {
  width: 100px;
  display: flex;
}
.paddingLR6 {
  padding: 0 6px;
}
.fixed300 {
  width: 300px;
}
.fixed500 {
  width: 500px;
}
.flexBetween {
  display: flex;
  justify-content: space-between;
}
.flexCenter {
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
}
.el-form {
  font-size: 12px !important;
  color: #595961;
}
</style>
